import * as React from "react";
import { SVGProps, memo } from "react";

const SvgLightGreenDownArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg width={65} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32.5 16 .5 0h64l-32 16Z" fill="#D9F2E5" />
  </svg>
);

const Memo = memo(SvgLightGreenDownArrow);

export default Memo;
